import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../util/Rest';
import {DEBTOR} from '../../constants/MicroServiceConstants';
import {deleteWorkQueueByAccountNumber} from './WorkQueue';
import {
  clearWindowError,
  deleteModifiedWindowSessionItem,
  removeModifiedWindow,
} from "./ModifiedWindows";

const initialData = {
  specNotesData: {},
  specNotesStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'specnotes',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    getSpecNotesData: (state, action) => {
      state.specNotesData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postSpecNotesData: (state, action) => {
      state.specNotesStatus = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
    },
    setNotesReduxState: (state, action) => {
      state[action.payload.property] = action?.payload?.value;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload;
      state.isLoading = false;
    },
    resetSpecialNoteStatus: (state) => {
      state.specNotesStatus = null;
      state.isLoading = false;
    },
    resetSuccess: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  getSpecNotesData,
  resetSpecialNoteStatus,
  postSpecNotesData,
  fetchStart,
  fetchError,
  fetchSuccess,
  resetSuccess,
  setNotesReduxState,
} = slice.actions;

export const getSpecNotes = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${DEBTOR}/find/specnotes/${accountNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getSpecNotesData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postSpecNotes = ({isDirty, ...details}) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${DEBTOR}/save/specnotes`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(
            deleteWorkQueueByAccountNumber({accountNumber: details?.accountNumber, isDirty}),
          );
          deleteModifiedWindowSessionItem("Important Notes");
          dispatch(removeModifiedWindow({ windowName: "Important Notes" }));
          dispatch(clearWindowError({ windowName: "Important Notes" }));
          dispatch(postSpecNotesData(data.status));
          dispatch(fetchSuccess(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const SuccessMsg = () => {
  return (dispatch) => {
    dispatch(resetSuccess());
  };
};
export const resetSpecialNote = () => {
  return (dispatch) => {
    dispatch(resetSpecialNoteStatus());
  };
};
